<template>
  <div>
    <div class="p-lg">
      <h1>Videos</h1>
    </div>

    <hr />

    <div class="p-lg">
      <div class="mb-lg">
        <p><strong>WistiaVideo component (inline)</strong></p>
        <WistiaVideo
          class="w-full lg:w-1/2"
          ref="video"
          mediaId="an9jkn0jo8"
        />
      </div>
      <div>
        <button
          @click="video.play()"
          class="mr-sm">
          Play
        </button>
        <button @click="video.pause()">
          Pause
        </button>
      </div>
    </div>

    <div class="p-lg">
      <div class="mb-lg">
        <p><strong>WistiaVideo component (inline, autoplay, looping, muted)</strong></p>
        <WistiaVideo
          class="w-full lg:w-1/2"
          ref="video"
          mediaId="an9jkn0jo8"
          endBehavior="loop"
          :autoplay="true"
          :muted="true"
        />
      </div>
    </div>

    <hr />

    <div class="p-lg">
      <div class="mb-lg">
        <p><strong>WistiaVideoModal component</strong></p>
        <WistiaVideoModal
          v-slot="{ display }"
          mediaId="an9jkn0jo8"
        >
          <p>Triggered by image (72px thumbnail)</p>
          <button
            class="bg-transparent border-none p-0 cursor-pointer"
            @click="display"
          >
            <img
              src="https://embed.wistia.com/deliveries/58a020602984808592f1f8aa5485268c.jpg?video_still_time=0"
              class="w-xxl inline-block"
            />
          </button>
          <br />
          <p>Triggered by text button</p>
          <button @click="display">
            Trigger modal
          </button>
        </WistiaVideoModal>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { WistiaVideo, WistiaVideoModal } from '@/components/library/video';

/**
 * HTML ref (value needs to be the same as the one in `ref="video"` in the
 * template) so that it exposes the play() and pause() methods
 */
const video = ref('video');
</script>
